import { gql } from '@apollo/client';

const GET_APPRAISER_SELECTION_LIST = gql`
  query GetAppraiserSelectionList($systemRoleId: Int) {
    appraiserSelectionList(systemRoleId: $systemRoleId) {
      DesiredRoleOptions {
        Title
        Value
      }
      CurrentRoleOptions {
        Title
        Value
        AffiliationType
      }
      TimeZoneOptions {
        Title
        Value
      }
      DirectChannelOptions {
        Title
        Value
      }
      ObservationOptions {
        Title
        Value
      }
    }
  }
`;

export default GET_APPRAISER_SELECTION_LIST;
